module.exports = __webpack_public_path__ + "static/quiz_question_girl_boy_false_bg_mobile-2f14056691e8c71cc7f7ad1d63790a2f.svg";